import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

const Email = ({ errors, email, onChange }) => (
  <div className={`form-element large ${errors.email ? 'has-errors' : ''}`}>
    <label className='block'>{I18n.t('pages.contact.email')}</label>
    <input type='text' value={email} onChange={event => onChange(event.target.value)} className='input-text' />
    {errors && errors.email ? <div className='simple-error'>{errors.email}</div> : null}
  </div>
)

export default Email

Email.propTypes = {
  onChange: PropTypes.func,
  email: PropTypes.string,
  errors: PropTypes.object
}
